import(/* webpackMode: "eager" */ "/var/www/frontend/src/components/index.tsx");
import(/* webpackMode: "eager" */ "/var/www/frontend/src/tehranto/loading/loading.index.tsx")